import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import styles from "./sk-Link.module.css";
export function Link({ as: Tag, children, className, onBackground = "light", target, variant = "body1", ...restProps }) {
    const Component = (Tag || "a");
    const isExternal = target === "_blank";
    const mainClassNames = clsx(className, styles.main, {
        [styles[`main--${onBackground}`]]: !!onBackground,
        [styles[`main--${variant}`]]: !!variant,
        [styles["main--external"]]: isExternal,
    });
    return (_jsx(Component, { ...restProps, target: target, className: mainClassNames, children: children }));
}
Link.displayName = "Link";
//# sourceMappingURL=Link.js.map